export const REORDER_MOVE_TYPES = {
  TOP_OF_PAGE: "Top",
  NORMAL: "Normal",
  BOTTOM_OF_PAGE: "Bottom",
};
